/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
export * from './typed';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function deepExtend(target, ...sources) {
    sources.forEach(source => {
        Object.entries(source).forEach(([key, val]) => {
            if (typeof val !== 'object' || Array.isArray(val) || val == null) {
                target[key] = val;
                return;
            }
            if (!Object.prototype.hasOwnProperty.call(target, key) ||
                typeof target[key] !== 'object') {
                target[key] = {};
            }
            deepExtend(target[key], val);
        });
    });
    return target;
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function deepExtendArray(target, ...sources) {
    // deepExtend with support for arrays. We couldn't rewrite deepExtend to
    // support arrays, because there are places in our codebase where we depend
    // on the property that it doesn't.
    sources.forEach(source => {
        Object.entries(source).forEach(([key, val]) => {
            if (typeof val !== 'object' || val == null) {
                target[key] = val;
                return;
            }
            if (!Object.prototype.hasOwnProperty.call(target, key) ||
                typeof target[key] !== 'object') {
                target[key] = Array.isArray(val) ? [] : {};
            }
            deepExtendArray(target[key], val);
        });
    });
    return target;
}
